import { graphql } from "api/cms-website/generated";

export const AwardsFragment = graphql(/* GraphQL */ `
    fragment AwardsFragment on ComponentComponentsAwards {
        id
        noMarginBottom
    }
`);
